import React, { useCallback, useEffect, useMemo, useState } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, TabbedItem, TabPanelOptions, Tab, ButtonItem, EmptyItem } from "devextreme-react/form";
import IClient from "../../models/IClient";
import Guid from "../../models/Guid";
import { Button } from 'devextreme-react/button';
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import { NumberBox, TextBox, CheckBox, TextArea, SelectBox } from 'devextreme-react';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import ScrollView from 'devextreme-react/scroll-view';
import useLookUpBase from '../../components/selectbox/LookupBase';
import { selected } from '@devexpress/analytics-core/queryBuilder-metadata';

const mailingTypes = ['Courriels', 'Étiquettes'];
const languesTypes = ['Tous', 'Français', 'Anglais'];

export default function GestionPublipostage() {
  const clientFormDataSource = useCustomDataSource<IClient, IClient>({ path: "client", primaryKey: "idClient", customReadAllPath: "client/read-list" });
  const { selectedDataRow: selectedClient, mode, setMode, isFieldModifier, setSelectedDataRow, setIsFieldModifier } = clientFormDataSource;
  const { editorOptions: typesUnitesEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "typeunite", setDataRow: () => setDataRow("idTypeUnite"), showClear: mode !== Mode.Lecture });
  const { editorOptions: typeSejourEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'typesejours', setDataRow: () => setDataRow("idTypeSejour"), showClear: mode !== Mode.Lecture });

  const [selectedSortFields, setSelectedSortFields] = useState<string[]>([]);
  const [dateDebut, setDateDebut] = useState<Date | null>(null);
  const [dateFin, setDateFin] = useState<Date | null>(null);

  const setDataRow = (e: string) => {
    setSelectedDataRow((prev: IClient) => (
      { ...prev, [e]: Guid.empty.toString() }
    ));
    setIsFieldModifier(true);
  }
  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IClient) => {
      return { ...prev, [e]: item.id }
    })
  }

  const handleSortFieldChange = (e: any) => {
    const fieldName = e.component.option('text');
    if (e.value) {
      setSelectedSortFields(prev => [...prev, fieldName]);
    } else {
      setSelectedSortFields(prev => prev.filter(field => field !== fieldName));
    }
  };

  const radioGroupOptions = useMemo(() => {
    return {
      items: mailingTypes,
      // value: formData.code,
      layout: 'horizontal'
    }
  }, []);

  const etiquettesGroupOptions = useMemo(() => {
    return {
      dataSource: ["Avery4146", "Avery5160", "Avery5161", "Avery5162", "Avery5261"],
      layout: "horizontal"
    }
  }, []);

  const langueEditorOptions = useMemo(() => {
    return {
      items: languesTypes,
      layout: 'horizontal'
    }
  }, []);

  const dateBoxOptions = useMemo(() => {
    return {
      displayFormat: 'dd-MM-yyyy',
      type: 'date' as const,
      dateSerializationFormat: 'yyyy-MM-dd',
    }
  }, []);

  const disabledEditorOptions = useMemo(() => {
    return {
      // disabled: selectedClient?.membres ? true : false
      disabled: true
    }
  }, []);

  const anneeCourantOptions = useMemo(() => {
    return {
      text: 'Année courante',
      onClick: () => {
        const currentDate = new Date();
        const nextYear = new Date();
        nextYear.setFullYear(currentDate.getFullYear() + 1);

        setDateDebut(currentDate);
        setDateFin(nextYear);
      }
    }
  }, []);


  const moisCourantOptions = useMemo(() => {
    return {
      text: 'Mois courant',
      onClick: () => {
        const currentDate = new Date();
        // First day of current month
        const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        // Last day of current month
        const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

        setDateDebut(firstDay);
        setDateFin(lastDay);
      }
    }
  }, []);

  return (
    <Popup
      visible={true}
      // visible={this.state.popupVisible}
      // onHiding={this.hideInfo}
      dragEnabled={true}
      hideOnOutsideClick={true}
      showCloseButton={false}
      showTitle={true}
      title="Publipostage"
      container=".dx-viewport"
      width={"max-content"}
      // width={800}
      height={550}
    >
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <ScrollView style={{ flex: 1 }}>
          <FormListBase data={clientFormDataSource}
            hideList={true} hideToolbar={true}
          >
            <FormListBaseTab>
              <TabItem title="Clients">
                <div style={{ display: "flex" }}>
                  <div style={{ width: "100%" }}>
                    <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                      <GroupItem colCount={3}>
                        <GroupItem colCount={1}>
                          <GroupItem caption='Type de publipostage'>
                            <SimpleItem key={"frm-type"} editorType="dxRadioGroup" editorOptions={radioGroupOptions}>
                              <Label text={"Type de publipostage"} />
                            </SimpleItem>
                            {selectedClient?.codeClient === "Étiquettes" &&
                              <SimpleItem key={"frm-format"} editorType="dxSelectBox" editorOptions={etiquettesGroupOptions}>
                                <Label text={"Format d'étiquettes"} />
                              </SimpleItem>
                            }
                          </GroupItem>
                          <GroupItem caption='Options'>
                            <SimpleItem key={"frm-clientSansCourriel"} editorType="dxCheckBox">
                              <Label text={"Clients sans courriel seulement"} />
                            </SimpleItem>
                            <SimpleItem key={"frm-clientAvecCourriel"} editorType="dxCheckBox">
                              <Label text={"Clients avec courriel seulement"} />
                            </SimpleItem>
                            <SimpleItem key={"frm-cacher-pays"} editorType="dxCheckBox">
                              <Label text={"Cacher le pays courant lors de l'impression"} />
                            </SimpleItem>
                            <SimpleItem key={"frm-inclure-liste-noire"} editorType="dxCheckBox">
                              <Label text={"Inclure les clients sur la liste noire"} />
                            </SimpleItem>
                          </GroupItem>
                          <GroupItem caption='Sélection de la langue'>
                            <SimpleItem key={"frm-langue"} editorType="dxRadioGroup" editorOptions={langueEditorOptions}>
                              <Label visible={false} />
                            </SimpleItem>
                          </GroupItem>
                          <GroupItem caption='Paramètres de tri'>
                            <GroupItem colCount={2}>
                              <GroupItem>
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "Adresse",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "Catégorie de client",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "Code Postal",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "No. membre",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "Nom, Prénom",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "Prénom, Nom",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "Pays",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "Province",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                                <SimpleItem editorType="dxCheckBox"
                                  editorOptions={{
                                    text: "Ville",
                                    onValueChanged: handleSortFieldChange
                                  }}
                                />
                              </GroupItem>
                              <GroupItem>
                                <GroupItem caption="Ordre du tri">
                                  <SimpleItem
                                    // editorType="dxList"
                                    editorOptions={{
                                      items: selectedSortFields,
                                      showScrollbar: "always"
                                    }}
                                  />
                                </GroupItem>
                              </GroupItem>
                            </GroupItem>
                          </GroupItem>
                          <GroupItem>
                            <SimpleItem editorType="dxRadioGroup"
                              editorOptions={{
                                items: ["Croissant", "Décroissant"],
                                layout: 'horizontal'
                              }}
                            />
                          </GroupItem>
                        </GroupItem>
                        <GroupItem colSpan={2}>
                          <GroupItem>
                            <TabbedItem>
                              {/* <TabPanelOptions height={"100%"} />
                              <Tab title={"Réservations"}>
                                <GroupItem colSpan={1}>
                                  
                                </GroupItem>
                              </Tab> */}

                              <Tab title={"Réservations"}>
                                <GroupItem colCount={3}>
                                  <GroupItem alignItemLabels={false}
                                    colSpan={2}
                                  >
                                    <SimpleItem
                                      key="frm-dateFin"
                                      editorType="dxDateBox"
                                      editorOptions={{
                                        ...dateBoxOptions,
                                        value: dateFin
                                      }}
                                    >
                                      <Label text="Date de fin" />
                                    </SimpleItem>
                                  </GroupItem>
                                  <GroupItem>
                                    <ButtonItem
                                      buttonOptions={anneeCourantOptions}
                                      colSpan={1}
                                    />
                                  </GroupItem>
                                </GroupItem>

                                <GroupItem colCount={3}>
                                  <GroupItem alignItemLabels={false}
                                    colSpan={2}
                                  >
                                    <SimpleItem
                                      key="frm-dateDebut"
                                      editorType="dxDateBox"
                                      editorOptions={{
                                        ...dateBoxOptions,
                                        value: dateDebut
                                      }}
                                    >
                                      <Label text="Date de début" />
                                    </SimpleItem>
                                  </GroupItem>
                                  <GroupItem>
                                    <ButtonItem
                                      buttonOptions={moisCourantOptions}
                                      colSpan={1}
                                    />
                                  </GroupItem>
                                </GroupItem>
                                <GroupItem caption="Types d'unités">
                                  {typesUnitesEditorOption.dataSource?.map((item: any) => (
                                    <SimpleItem
                                      key={item.id}
                                      editorType="dxCheckBox"
                                      editorOptions={{
                                        text: item.description,
                                        value: false,
                                        onValueChanged: (e: any) => onSelectionchanged(item, "idTypeUnite")
                                      }}
                                    />
                                  ))}
                                </GroupItem>
                                <GroupItem caption="Statuts de réservation" colSpan={2}>
                                  <GroupItem colCount={1}>
                                    <SimpleItem key={"fml-en-cours"} dataField="enCours" editorType="dxCheckBox">
                                      <Label text={"En cours"} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-arrive"} dataField="arrive" editorType="dxCheckBox">
                                      <Label text={"Arrivé"} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-soumission"} dataField="soumission" editorType="dxCheckBox">
                                      <Label text={"Soumission"} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-reservation"} dataField="reservation" editorType="dxCheckBox">
                                      <Label text={"Réservation payée"} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-quitte"} dataField="quitte" editorType="dxCheckBox">
                                      <Label text={"A quitté"} />
                                    </SimpleItem>
                                  </GroupItem>
                                  <GroupItem colCount={1}>
                                    <SimpleItem key={"fml-non-confirme"} dataField="nonConfirme" editorType="dxCheckBox">
                                      <Label text={"En cours"} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-confirme"} dataField="confirme" editorType="dxCheckBox">
                                      <Label text={"Confirmé"} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-facture"} dataField="facturePayee" editorType="dxCheckBox">
                                      <Label text={"Facture payée"} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-document"} dataField="documentRecu" editorType="dxCheckBox">
                                      <Label text={"Document reçu"} />
                                    </SimpleItem>
                                  </GroupItem>
                                </GroupItem>
                              </Tab>
                              <Tab title={"Membres"}>
                                <GroupItem colCount={2}>
                                  <GroupItem colSpan={1}>
                                    <SimpleItem key={"fml-membres"} dataField="memnres" editorType="dxCheckBox">
                                      <Label text={"Membres"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-conjoints"} dataField="conjoints" editorType="dxCheckBox" editorOptions={disabledEditorOptions}>
                                      <Label text={"Personnes conjointes"} showColon={false} />
                                    </SimpleItem>
                                  </GroupItem>
                                  <GroupItem colSpan={1} caption='Années des membres'
                                    alignItemLabels={false}
                                  >
                                    <SimpleItem key={"fml-2020"} dataField="2020" editorType="dxCheckBox" editorOptions={disabledEditorOptions}>
                                      <Label text={"2020"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2021"} dataField="2021" editorType="dxCheckBox" editorOptions={disabledEditorOptions}>
                                      <Label text={"2021"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2022"} dataField="2022" editorType="dxCheckBox" editorOptions={disabledEditorOptions}>
                                      <Label text={"2022"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2023"} dataField="2023" editorType="dxCheckBox" editorOptions={disabledEditorOptions}>
                                      <Label text={"2023"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2024"} dataField="2024" editorType="dxCheckBox" editorOptions={disabledEditorOptions}>
                                      <Label text={"2024"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2025"} dataField="2025" editorType="dxCheckBox" editorOptions={disabledEditorOptions}>
                                      <Label text={"2025"} showColon={false} />
                                    </SimpleItem>
                                  </GroupItem>
                                </GroupItem>
                              </Tab>
                              <Tab title={"Factures"}>
                                <GroupItem caption='Année de facturation'>
                                  <SimpleItem key={"fml-2020"} dataField="2020" editorType="dxCheckBox">
                                    <Label text={"2020"} showColon={false} />
                                    <SimpleItem key={"fml-2021"} dataField="2021" editorType="dxCheckBox">
                                      <Label text={"2021"} showColon={false} />
                                    </SimpleItem>
                                  </SimpleItem>
                                </GroupItem>
                              </Tab>
                              <Tab title={"Enregistrements"}>
                                <GroupItem colCount={2}>
                                  <GroupItem colSpan={1}>
                                    <SimpleItem key={"fml-2020"} dataField="2020" editorType="dxCheckBox" >
                                      <Label text={"2020"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2021"} dataField="2021" editorType="dxCheckBox" >
                                      <Label text={"2021"} showColon={false} />
                                    </SimpleItem>
                                  </GroupItem>
                                  <GroupItem colSpan={1} caption='Années des membres'
                                  >
                                    <SimpleItem key={"fml-aucun"} dataField="aucun" editorType="dxCheckBox" >
                                      <Label text={"aucun"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-college"} dataField="college" editorType="dxCheckBox">
                                      <Label text={"collège"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-depanneur"} dataField="depanneur" editorType="dxCheckBox" >
                                      <Label text={"dépanneur"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-web"} dataField="web" editorType="dxCheckBox">
                                      <Label text={"web"} showColon={false} />
                                    </SimpleItem>
                                  </GroupItem>
                                </GroupItem>
                                <SimpleItem key={"fml-feuillet"} dataField="feuillet" editorType="dxCheckBox">
                                  <Label text={"Feuillets non remis"} showColon={false} />
                                </SimpleItem>
                              </Tab>
                              <Tab title={"Dossiers clients"}>
                                <GroupItem colCount={2}>
                                  <GroupItem colSpan={1} caption='Années de création du client'>
                                    <SimpleItem key={"fml-2020"} dataField="2020" editorType="dxCheckBox" >
                                      <Label text={"2020"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2021"} dataField="2021" editorType="dxCheckBox" >
                                      <Label text={"2021"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2022"} dataField="2022" editorType="dxCheckBox" >
                                      <Label text={"2022"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2023"} dataField="2023" editorType="dxCheckBox" >
                                      <Label text={"2023"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2024"} dataField="2024" editorType="dxCheckBox" >
                                      <Label text={"2024"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2025"} dataField="2025" editorType="dxCheckBox" >
                                      <Label text={"2025"} showColon={false} />
                                    </SimpleItem>
                                  </GroupItem>
                                  <GroupItem colSpan={1} caption='Années de modification du client'
                                  >
                                    <SimpleItem key={"fml-2020"} dataField="2020" editorType="dxCheckBox" >
                                      <Label text={"2020"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2021"} dataField="2021" editorType="dxCheckBox" >
                                      <Label text={"2021"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2022"} dataField="2022" editorType="dxCheckBox" >
                                      <Label text={"2022"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2023"} dataField="2023" editorType="dxCheckBox" >
                                      <Label text={"2023"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2024"} dataField="2024" editorType="dxCheckBox" >
                                      <Label text={"2024"} showColon={false} />
                                    </SimpleItem>
                                    <SimpleItem key={"fml-2025"} dataField="2025" editorType="dxCheckBox" >
                                      <Label text={"2025"} showColon={false} />
                                    </SimpleItem>
                                  </GroupItem>
                                </GroupItem>
                              </Tab>
                            </TabbedItem>
                          </GroupItem>

                        </GroupItem>
                      </GroupItem>
                    </Form>
                  </div>
                </div>
              </TabItem>
              <TabItem title="Types de séjour">
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  {/* <GroupItem colCount={3}>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} height={500}>
                      </DataGrid>
                    </GroupItem>
                    <GroupItem>
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text=">"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px' }}
                        width={25}
                        text=">>"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} style={{ marginLeft: '-70px' }} height={500}>
                      </DataGrid>
                    </GroupItem>
                  </GroupItem> */}
                  <GroupItem colCount={3}>
                    <GroupItem>
                      <DataGrid
                        showBorders={true}
                        allowColumnResizing={true}
                        width={250}
                        height={500}
                        dataSource={typeSejourEditorOption.dataSource}
                      >
                        {/* <Column dataField="text" caption="" /> */}
                        <Column dataField="description" caption="" />
                      </DataGrid>
                    </GroupItem>
                    <GroupItem cssClass="dx-widget" alignItemLabels={false}>
                      <Button
                        width={60}
                        text="<<"
                        type="normal"
                        stylingMode="contained"
                      />
                      <Button
                        width={60}
                        text="►"
                        type="normal"
                        stylingMode="contained"
                      />
                      <Button
                        width={60}
                        text="◄"
                        type="normal"
                        stylingMode="contained"
                      />
                      <Button
                        width={60}
                        text=">>"
                        type="normal"
                        stylingMode="contained"
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid
                        showBorders={true}
                        allowColumnResizing={true}
                        width={250}
                        height={500}
                      >
                        <Column dataField="text" caption="" />
                      </DataGrid>
                    </GroupItem>
                  </GroupItem>
                </Form>
              </TabItem>
              <TabItem title="Lieux de séjour">
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem colCount={3}>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} height={500}>
                      </DataGrid>
                    </GroupItem>
                    <GroupItem>
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text=">"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px' }}
                        width={25}
                        text=">>"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} style={{ marginLeft: '-70px' }} height={500}>
                      </DataGrid>
                    </GroupItem>
                  </GroupItem>
                </Form>
              </TabItem>
              <TabItem title="Villes">
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem colCount={3}>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} height={500}>
                      </DataGrid>
                    </GroupItem>
                    <GroupItem>
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text=">"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px' }}
                        width={25}
                        text=">>"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} style={{ marginLeft: '-70px' }} height={500}>
                      </DataGrid>
                    </GroupItem>
                  </GroupItem>
                </Form>
              </TabItem>
              <TabItem title="Provinces">
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem colCount={3}>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} height={500}>
                      </DataGrid>
                    </GroupItem>
                    <GroupItem>
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text=">"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px' }}
                        width={25}
                        text=">>"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} style={{ marginLeft: '-70px' }} height={500}>
                      </DataGrid>
                    </GroupItem>
                  </GroupItem>
                </Form>
              </TabItem>
              <TabItem title="Activités">
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem colCount={3}>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} height={500}>
                      </DataGrid>
                    </GroupItem>
                    <GroupItem>
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text=">"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px' }}
                        width={25}
                        text=">>"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} style={{ marginLeft: '-70px' }} height={500}>
                      </DataGrid>
                    </GroupItem>
                  </GroupItem>
                </Form>
              </TabItem>
              <TabItem title="Catégorie client">
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem colCount={3}>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} height={500}>
                      </DataGrid>
                    </GroupItem>
                    <GroupItem>
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text=">"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px' }}
                        width={25}
                        text=">>"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} style={{ marginLeft: '-70px' }} height={500}>
                      </DataGrid>
                    </GroupItem>
                  </GroupItem>
                </Form>
              </TabItem>
              <TabItem title="Publicité">
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem colCount={3}>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} height={500}>
                      </DataGrid>
                    </GroupItem>
                    <GroupItem>
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text=">"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px', marginBottom: '5px' }}
                        width={25}
                        text="<<"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '49px' }}
                        width={25}
                        text=">>"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true} width={250} style={{ marginLeft: '-70px' }} height={500}>
                      </DataGrid>
                    </GroupItem>
                  </GroupItem>
                </Form>
              </TabItem>
              <TabItem title="Résultats de la sélection">
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem>
                    <GroupItem colCount={3}>
                      <Button
                        text="Sélectionner tout"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        text="Déselectionner tout"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                      <Button
                        style={{ marginLeft: '50px' }}
                        text="Exporter la liste"
                        type="normal"
                        stylingMode="contained"
                      // onClick={this.onClick}
                      />
                    </GroupItem>
                    <GroupItem>
                      <DataGrid showBorders={true} allowColumnResizing={true}>
                        <Column caption={"Sélection"} />
                        <Column caption={"Nom"} />
                        <Column caption={"Adresse"} />
                        <Column caption={"Ville"} />
                        <Column caption={"Province"} />
                        <Column caption={"Pays"} />
                        <Column caption={"Code postal"} />
                        <Column caption={"Courriel"} />
                        <Column caption={"Téléphone"} />
                      </DataGrid>
                    </GroupItem>
                    <GroupItem>
                      <Label text={"Nombre d'enregistrement(s) : 0"} />
                    </GroupItem>
                  </GroupItem>
                </Form>
              </TabItem>
            </FormListBaseTab>
          </FormListBase>
        </ScrollView>
        <div style={{
          display: 'flex',
          justifyContent: 'right',
          alignItems: 'right',
          gap: '10px',
          padding: '10px 10px 0 0',
          borderTop: '1px solid #ddd',
          backgroundColor: 'white'
        }}>
          <Button
            text="Précédent"
            type="normal"
            stylingMode="contained"
          />
          <Button
            text="Suivant"
            type="normal"
            stylingMode="contained"
          />
          <Button
            text="Démarrer"
            type="normal"
            stylingMode="contained"
          />
          <Button
            text="Fermer"
            type="normal"
            stylingMode="contained"
          />
        </div>
      </div>
    </Popup>
  );
}
